import React, { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import { useTranslation } from "react-i18next";
import { scrollToSectionId } from "../utils/scrollToSection";

const initialState = {
  name: "",
  email: "",
  tel: "",
  message: "",
};

const Message = () => {
  const { t } = useTranslation("forms");
  const [{ name, email, tel, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name: field, value } = e.target;
    setState((prev) => ({ ...prev, [field]: value }));
  };

  const clearState = () => setState({ ...initialState });

  useEffect(() => {
    const id = window.setTimeout(() => {
      scrollToSectionId("banner-contato");
    }, 80);
    return () => window.clearTimeout(id);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm("YOUR_SERVICE_ID", "YOUR_TEMPLATE_ID", e.target, "YOUR_PUBLIC_KEY")
      .then(
        () => {
          clearState();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <main className="inner-page inner-page--form">
      <header
        id="banner-contato"
        className="inner-page-hero inner-page-hero--compact"
      >
        <div className="container">
          <div className="inner-page-hero__text">
            <p className="inner-page-hero__eyebrow">{t("contact.eyebrow")}</p>
            <h1 className="inner-page-hero__title">{t("contact.title")}</h1>
            <p className="inner-page-hero__sub">{t("contact.sub")}</p>
          </div>
        </div>
      </header>

      <div className="container inner-page__body">
        <div className="form-shell form-shell--bare">
          <form
            name="sentMessage"
            className="inner-form inner-form--modern"
            onSubmit={handleSubmit}
          >
            <div className="inner-form__grid inner-form__grid--2">
              <div className="inner-form__field">
                <label htmlFor="msg-name">{t("contact.nameLabel")}</label>
                <input
                  type="text"
                  id="msg-name"
                  name="name"
                  className="form-control"
                  placeholder={t("contact.namePlaceholder")}
                  value={name}
                  required
                  onChange={handleChange}
                  autoComplete="name"
                />
              </div>
              <div className="inner-form__field">
                <label htmlFor="msg-email">{t("contact.emailLabel")}</label>
                <input
                  type="email"
                  id="msg-email"
                  name="email"
                  className="form-control"
                  placeholder={t("contact.emailPlaceholder")}
                  value={email}
                  required
                  onChange={handleChange}
                  autoComplete="email"
                />
              </div>
            </div>

            <div className="inner-form__field">
              <label htmlFor="msg-tel">{t("contact.telLabel")}</label>
              <input
                type="tel"
                id="msg-tel"
                name="tel"
                className="form-control"
                placeholder={t("contact.telPlaceholder")}
                value={tel}
                required
                onChange={handleChange}
                autoComplete="tel"
              />
            </div>

            <div className="inner-form__field">
              <label htmlFor="msg-message">{t("contact.messageLabel")}</label>
              <textarea
                name="message"
                id="msg-message"
                className="form-control inner-form__textarea"
                rows={6}
                placeholder={t("contact.messagePlaceholder")}
                value={message}
                required
                onChange={handleChange}
              />
            </div>

            <div className="inner-form__actions">
              <p className="inner-form__fineprint">{t("contact.fineprint")}</p>
              <button type="submit" className="inner-form__submit">
                {t("contact.submit")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
};

export default Message;
